export default {
	API_ENDPOINT: process.env.REACT_APP_API_HOST
};
